export default __webpack_public_path__ + "6b834e30c4bdd8351f957cdf23315545.png";